'use client';

import { useSession } from 'next-auth/react';
import { usePathname, useRouter } from 'next/navigation';
import { ReactNode, useEffect } from 'react';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';

interface AuthGuardProps {
  children: ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { data: session, status } = useSession();
  const pathname = usePathname();
  const router = useRouter();

  const isAuthRoute = pathname?.startsWith('/auth');
  const hasAssetCastAccess = session?.user?.tenants && session.user.tenants.length > 0;

  useEffect(() => {
    if (isAuthRoute) return;

    if (status === 'unauthenticated') {
      const callbackUrl = encodeURIComponent(pathname || '/dashboard');
      router.push(`/auth/signin?callbackUrl=${callbackUrl}`);
    } else if (status === 'authenticated' && !hasAssetCastAccess) {
      router.push('/auth/signin?error=no_tenant_access');
    }
  }, [status, session, isAuthRoute, pathname, router, hasAssetCastAccess]);

  if (isAuthRoute) {
    return <>{children}</>;
  }

  if (status === 'loading' || status === 'unauthenticated' || !hasAssetCastAccess) {
    return <LoadingSpinner />;
  }

  return <>{children}</>;
}
